import * as React from "react";
import { cn } from "../utils/cn";

export interface FieldProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: string;
  description?: string;
  error?: string;
  htmlFor?: string;
  labelClassName?: string;
  labelStyle?: React.CSSProperties;
}

export const Field = React.forwardRef<HTMLDivElement, FieldProps>(
  ({ label, description, error, children, className, htmlFor, labelClassName, labelStyle, ...props }, ref) => (
    <div ref={ref} className={cn("flex w-full flex-col gap-2", className)} {...props}>
      {label ? (
        <label htmlFor={htmlFor} className={cn("text-sm font-medium text-gray-700", labelClassName)} style={labelStyle}>
          {label}
        </label>
      ) : null}
      {children}
      {description ? <p className="text-xs text-gray-500">{description}</p> : null}
      {error ? <p className="text-xs font-medium text-danger-600">{error}</p> : null}
    </div>
  )
);

Field.displayName = "Field";
